import React from 'react';

/**
 * NodeConfigTabs — três abas do painel de configuração de node: Geral |
 * Filtros | Cancelamento (spec 2026-09-14 §1.1/§1.2). Substitui o antigo
 * `TriggerConfigTabs` (aposentado — a aba Filtros deixa de ser exclusiva dos
 * 3 gatilhos com filtro e a aba Cancelamento entra em TODO node).
 *
 * Mesmo visual do componente que substitui: cor ativa `#8b5cf6`, inativa
 * SEMPRE `var(--theme-muted-text)` (respeita dark mode).
 */

export type NodeConfigTab = 'general' | 'filters' | 'cancellation';

export interface NodeConfigTabsProps {
  /** Aba ativa */
  active: NodeConfigTab;
  /** Troca de aba */
  onChange: (tab: NodeConfigTab) => void;
  /** A aba Filtros só aparece nos 3 gatilhos que já a tinham nesta fase */
  showFilters: boolean;
  /** Contagem de filtros — exibida como sufixo "(N)" na aba Filtros quando > 0 */
  filtersCount: number;
  /** Contagem de regras de cancelamento — sufixo "(N)" na aba Cancelamento quando > 0 */
  cancellationCount: number;
}

export const NodeConfigTabs: React.FC<NodeConfigTabsProps> = ({
  active,
  onChange,
  showFilters,
  filtersCount,
  cancellationCount,
}) => {
  const tabs: Array<{ id: NodeConfigTab; label: string }> = [
    { id: 'general', label: 'Geral' },
    ...(showFilters ? [{ id: 'filters' as const, label: filtersCount > 0 ? `Filtros (${filtersCount})` : 'Filtros' }] : []),
    { id: 'cancellation', label: cancellationCount > 0 ? `Cancelamento (${cancellationCount})` : 'Cancelamento' },
  ];

  return (
    <div className="flex border-b" style={{ borderColor: 'var(--theme-card-border)' }}>
      {tabs.map((tab) => {
        const isActive = active === tab.id;
        return (
          <button
            key={tab.id}
            type="button"
            className="px-4 py-2 text-xs font-medium transition-colors"
            style={{
              color: isActive ? '#8b5cf6' : 'var(--theme-muted-text)',
              borderBottom: isActive ? '2px solid #8b5cf6' : '2px solid transparent',
            }}
            onClick={() => onChange(tab.id)}
            data-testid={`node-config-tab-${tab.id}`}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
};

export default NodeConfigTabs;
